export default __webpack_public_path__ + "static/media/Morning-Read.a325c774.jpg";